import React, { useEffect, useState } from "react";
import "./Confetti.css";

const COLORS = ["#7c5cff", "#c84bff", "#2ee6ff", "#2bf5a6", "#ffcf5c"];

// Renders a one-shot confetti burst, then unmounts itself.
export default function Confetti({ pieces = 36, duration = 1800 }) {
  const [on, setOn] = useState(true);
  useEffect(() => {
    const t = setTimeout(() => setOn(false), duration);
    return () => clearTimeout(t);
  }, [duration]);

  if (!on) return null;

  return (
    <div className="confetti">
      {Array.from({ length: pieces }, (_, i) => {
        const left = (i / pieces) * 100;
        const delay = (i % 6) * 60;
        const color = COLORS[i % COLORS.length];
        const rot = (i * 47) % 360;
        return (
          <span
            key={i}
            className="confetti-bit"
            style={{
              left: `${left}%`,
              background: color,
              animationDelay: `${delay}ms`,
              transform: `rotate(${rot}deg)`,
            }}
          />
        );
      })}
    </div>
  );
}
